(function () {
  'use strict';

  function toggleElement(button, element) {
    if (!button || !element) return;
    var willOpen = element.hasAttribute('hidden');
    if (willOpen) element.removeAttribute('hidden');
    else element.setAttribute('hidden', 'hidden');
    button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var menuButton = document.querySelector('[data-nexa-menu-button]');
    var mobileMenu = document.getElementById('NexaMobileMenu');
    var searchButton = document.querySelector('[data-nexa-search-button]');
    var searchPanel = document.getElementById('NexaSearch');

    if (menuButton) {
      menuButton.addEventListener('click', function () {
        toggleElement(menuButton, mobileMenu);
      });
    }

    if (searchButton) {
      searchButton.addEventListener('click', function () {
        toggleElement(searchButton, searchPanel);
        if (searchPanel && !searchPanel.hasAttribute('hidden')) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }
  });
})();
